/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'home',
                component: () => import('./views/Home.vue')
              },
              // =============================================================================
              // Infraestructure
              // =============================================================================
              {
                path: '/infra/parameters',
                name: 'parameters',
                component: () => import('./views/infra/parameters/Parameters.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Parámetros', active: true},
                  ],
                  pageTitle: 'Parámetros'
                },
              },
              {
                path: '/infra/parameter/:id',
                name: 'parameter',
                component: () => import('./views/infra/parameters/Parameter.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Parámetros', url: '/infra/parameters'},
                    {title: 'Parámetro', active: true},
                  ],
                  pageTitle: 'Parámetro'
                },
              },
              {
                path: '/infra/lists',
                name: 'lists',
                component: () => import('./views/infra/lists/Lists.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Listas', active: true},
                  ],
                  pageTitle: 'Listas'
                },
              },
              {
                path: '/infra/list/value/:id',
                name: 'list_value',
                component: () => import('./views/infra/lists/ListValue.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Listas', url: '/infra/lists'},
                    {title: 'Valor de lista', active: true},
                  ],
                  pageTitle: 'Valor de lista'
                },
              },
              {
                path: '/infra/roles',
                name: 'roles',
                component: () => import('./views/infra/roles/Roles.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Roles', active: true},
                  ],
                  pageTitle: 'Roles'
                },
              },
              {
                path: '/infra/role/:id',
                name: 'role',
                component: () => import('./views/infra/roles/Role.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Roles', url: '/infra/roles'},
                    {title: 'Datos del rol', active: true},
                  ],
                  pageTitle: 'Datos del rol'
                },
              },
              {
                path: '/infra/users',
                name: 'users',
                component: () => import('./views/infra/users/Users.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Usuarios', active: true},
                  ],
                  pageTitle: 'Usuarios'
                },
              },
              {
                path: '/infra/user/:id',
                name: 'user',
                component: () => import('./views/infra/users/User.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Usuarios', url: '/infra/users'},
                    {title: 'Datos del usuario', active: true},
                  ],
                  pageTitle: 'Datos del usuario'
                },
              },
              {
                path: '/infra/branches',
                name: 'branches',
                component: () => import('./views/infra/branches/Branches.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Empresas', active: true},
                  ],
                  pageTitle: 'Empresas'
                },
              },
              {
                path: '/infra/branch/:id',
                name: 'branch',
                component: () => import('./views/infra/branches/Branch.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Empresas', url: '/infra/branches'},
                    {title: 'Datos de la empresa', active: true},
                  ],
                  pageTitle: 'Editando empresa'
                },
              },
              // =============================================================================
              // Products
              // =============================================================================
              {
                path: '/catalogs/products/categories',
                name: 'categories',
                component: () => import('./views/catalogs/categories/Categories.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Productos', url: '/products'},
                    {title: 'Categorías', active: true},
                  ],
                  pageTitle: 'Categorías'
                },
              },
              {
                path: '/catalogs/products/category/:id',
                name: 'category',
                component: () => import('./views/catalogs/categories/Category.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Productos', url: '/catalogs/products'},
                    {title: 'Categorías', url: '/catalogs/products/categories'},
                    {title: 'Detalle de categoría', active: true},
                  ],
                  pageTitle: 'Detalle de categoría'
                },
              },
              {
                path: '/catalogs/products',
                name: 'products',
                component: () => import('./views/catalogs/products/Products.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Productos', active: true},
                  ],
                  pageTitle: 'Productos'
                },
              },
              {
                path: '/catalogs/product/:id',
                name: 'product',
                component: () => import('./views/catalogs/products/Product.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Productos', url: '/catalogs/products'},
                    {title: 'Detalle de producto', active: true},
                  ],
                  pageTitle: 'Detalle de producto'
                },
              },
              // =============================================================================
              // Stock
              // =============================================================================
              {
                path: '/stock/warehouses',
                name: 'warehouses',
                component: () => import('./views/stock/warehouses/Warehouses.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Bodegas', active: true},
                  ],
                  pageTitle: 'Bodegas'
                },
              },
              {
                path: '/stock/warehouse/:id',
                name: 'warehouse',
                component: () => import('./views/stock/warehouses/Warehouse.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Bodegas', url: '/stock/warehouses'},
                    {title: 'Datos de la Bodega', active: true},
                  ],
                  pageTitle: 'Datos de la bodega'
                },
              },
              {
                path: '/stock/document_types',
                name: 'document_types',
                component: () => import('./views/stock/documentTypes/DocumentTypes.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Tipos de documento de inventario', active: true},
                  ],
                  pageTitle: 'Tipos de documento de inventario'
                },
              },
              {
                path: '/stock/document_type/:id',
                name: 'document_type',
                component: () => import('./views/stock/documentTypes/DocumentType.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Tipos de documento de inventario', url: '/stock/document_types'},
                    {title: 'Datos del tipo de documento', active: true},
                  ],
                  pageTitle: 'Datos del tipo de documento'
                },
              },
              // =============================================================================
              // Sale
              // =============================================================================
              {
                path: '/sale/document_types',
                name: 'sale_document_types',
                component: () => import('./views/sale/documentTypes/DocumentTypes.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Tipos de documento de ventas', active: true},
                  ],
                  pageTitle: 'Tipos de documento de ventas'
                },
              },
              {
                path: '/sale/document_type/:id',
                name: 'sale_document_type',
                component: () => import('./views/sale/documentTypes/DocumentType.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Tipos de documento de venta', url: '/sale/document_types'},
                    {title: 'Datos del tipo de documento', active: true},
                  ],
                  pageTitle: 'Datos del tipo de documento'
                },
              },
              {
                path: '/sale/resolutions',
                name: 'resolutions',
                component: () => import('./views/sale/resolutions/Resolutions'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Resoluciones de venta', active: true},
                  ],
                  pageTitle: 'Resoluciones de venta'
                },
              },
              {
                path: '/sale/resolution/:id',
                name: 'resolution',
                component: () => import('./views/sale/resolutions/Resolution.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Resoluciones de venta', url: '/sale/resolutions'},
                    {title: 'Datos de la resolución', active: true},
                  ],
                  pageTitle: 'Datos de la resolución'
                },
              },
              {
                path: '/sale/cash_registers',
                name: 'cash_registers',
                component: () => import('./views/sale/cashRegisters/CashRegisters'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Cajas', active: true},
                  ],
                  pageTitle: 'Cajas'
                },
              },
              {
                path: '/sale/cash_register/:id',
                name: 'cash_register',
                component: () => import('./views/sale/cashRegisters/CashRegister'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Cajas', url: '/sale/cash_registers'},
                    {title: 'Datos de la caja', active: true},
                  ],
                  pageTitle: 'Datos de la caja'
                },
              },
              {
                path: '/sale/session/:id',
                name: 'session',
                component: () => import('./views/sale/sessions/Session'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Sesiones de caja', url: '/sale/sessions'},
                    {title: 'Sesión de caja', active: true},
                  ],
                  pageTitle: 'Sesión de caja'
                },
              },
              {
                path: '/sale/price_lists',
                name: 'price_lists',
                component: () => import('./views/sale/priceLists/PriceLists'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Listas de precios', active: true},
                  ],
                  pageTitle: 'Listas de precios'
                },
              },
              {
                path: '/sale/price_list/:id',
                name: 'price_list',
                component: () => import('./views/sale/priceLists/PriceList'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Listas de precios', url: '/sale/price_lists'},
                    {title: 'Datos de la lista de precios', active: true},
                  ],
                  pageTitle: 'Lista de precios'
                },
              },
              {
                path: '/sale/customers',
                name: 'customers',
                component: () => import('./views/sale/customers/Customers'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Clientes', active: true},
                  ],
                  pageTitle: 'Clientes'
                },
              },
              {
                path: '/sale/customer/:id',
                name: 'customer',
                component: () => import('./views/sale/customers/Customer'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Clientes', url: '/sale/customers'},
                    {title: 'Datos de cliente', active: true},
                  ],
                  pageTitle: 'Datos de cliente'
                },
              },
              {
                path: '/infra/locations',
                name: 'locations',
                component: () => import('./views/sale/locations/Locations.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Ubicaciones', active: true},
                  ],
                  pageTitle: 'Ubicaciones'
                },
              },
              {
                path: '/infra/location/:id',
                name: 'location',
                component: () => import('./views/sale/locations/Location.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Ubicaciones', url: '/infra/locations'},
                    {title: 'Datos de la ubicación', active: true},
                  ],
                  pageTitle: 'Datos de la ubicación'
                },
              },
              {
                path: '/sale/transaction/:id',
                name: 'sale_transaction',
                component: () => import('./views/reports/sales/SaleTransaction.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Reportes', url: '#'},
                    {title: 'Ventas', url: '#'},
                    {title: 'Órdenes de venta', url: '/reports/sales/orders'},
                    {title: 'Transacción de venta', active: true},
                  ],
                  pageTitle: 'Transacción de venta'
                },
              },
              // =============================================================================
              // Transactions
              // =============================================================================
              {
                path: '/stock/transactions/list',
                name: 'stock_transactions',
                component: () => import('./views/stock/transactions/StockTransactions.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Operaciones', url: '#'},
                    {title: 'Inventario', url: '#'},
                    {title: 'Transacciones de inventario', active: true},
                  ],
                  pageTitle: 'Transacciones de inventario'
                },
              },
              {
                path: '/stock/transaction/:id',
                name: 'stock_transaction',
                component: () => import('./views/stock/transactions/StockTransaction.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Operaciones', url: '#'},
                    {title: 'Inventario', url: '#'},
                    {title: 'Transacciones', url: '/stock/transactions/list'},
                    {title: 'Transacción de inventario', active: true},
                  ],
                  pageTitle: 'Transacción de inventario'
                },
              },
              // =============================================================================
              // Inventories
              // =============================================================================
              {
                path: '/stock/inventories/list',
                name: 'stock_inventories',
                component: () => import('./views/stock/transactions/StockInventories'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Operaciones', url: '#'},
                    {title: 'Inventario', url: '#'},
                    {title: 'Inventarios físicos', active: true},
                  ],
                  pageTitle: 'Inventarios físicos'
                },
              },
              {
                path: '/stock/inventory/:id',
                name: 'stock_inventory',
                component: () => import('./views/stock/transactions/StockInventory'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Operaciones', url: '#'},
                    {title: 'Inventario', url: '#'},
                    {title: 'Inventarios físicos', url: '/stock/inventories/list'},
                    {title: 'Inventario físico', active: true},
                  ],
                  pageTitle: 'Inventario físico'
                },
              },
              // =============================================================================
              // Reports
              // =============================================================================
              {
                path: '/reports/sales/orders',
                name: 'saleOrdersReport',
                component: () => import('./views/reports/sales/SaleOrdersReport.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Reportes', url: '#'},
                    {title: 'Ventas', url: '#'},
                    {title: 'Órdenes de venta', active: true},
                  ],
                  pageTitle: 'Informe de órdenes de venta'
                },
              },
              {
                path: '/reports/sales/daily_sales',
                name: 'dailySalesReport',
                component: () => import('./views/reports/sales/DailySales.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Reportes', url: '#'},
                    {title: 'Ventas', url: '#'},
                    {title: 'Venta diaria', active: true},
                  ],
                  pageTitle: 'Venta diaria'
                },
              },
              {
                path: '/reports/sales/product_sales',
                name: 'productSalesReport',
                component: () => import('./views/reports/sales/ProductSales.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Reportes', url: '#'},
                    {title: 'Ventas', url: '#'},
                    {title: 'Venta por producto', active: true},
                  ],
                  pageTitle: 'Venta por producto'
                },
              },
              {
                path: '/reports/sales/customer_sales',
                name: 'customerSalesReport',
                component: () => import('./views/reports/sales/CustomerSales.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Reportes', url: '#'},
                    {title: 'Ventas', url: '#'},
                    {title: 'Venta por cliente', active: true},
                  ],
                  pageTitle: 'Venta por cliente'
                },
              },
              {
                path: '/reports/stock/stock',
                name: 'stockDateReport',
                component: () => import('./views/reports/stock/StockDateReport.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Reportes', url: '#'},
                    {title: 'Inventario', url: '#'},
                    {title: 'Existencias', active: true},
                  ],
                  pageTitle: 'Existencias'
                },
              },
              {
                path: '/reports/stock/kardex',
                name: 'stockKardex',
                component: () => import('./views/reports/stock/KardexReport.vue'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Reportes', url: '#'},
                    {title: 'Inventario', url: '#'},
                    {title: 'Kardex', active: true},
                  ],
                  pageTitle: 'Kardex'
                },
              },
              // =============================================================================
              // Statistics
              // =============================================================================
              {
                path: '/statistics/sales/customer_abc',
                name: 'customerABC',
                component: () => import('./views/statistics/sales/CustomersABC'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Estadísticas', url: '#'},
                    {title: 'Ventas', url: '#'},
                    {title: 'ABC de clientes', active: true},
                  ],
                  pageTitle: 'ABC de clientes'
                }
              },
              {
                path: '/statistics/sales/product_abc',
                name: 'productABC',
                component: () => import('./views/statistics/sales/ProductsABC'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Estadísticas', url: '#'},
                    {title: 'Ventas', url: '#'},
                    {title: 'ABC de productos', active: true},
                  ],
                  pageTitle: 'ABC de productos'
                },
              }
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/login',
                name: 'login',
                component: () => import('@/views/pages/Login.vue')
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
              {
                path: '/order',
                name: 'takeOrder',
                component: () => import('@/views/TakeOrder2.vue')
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

//
// Autenticación interna
//
router.beforeEach((to, from, next) => {
  if (store.state.AppActiveUser.token) {
    next()
  } else {
    if (to.name == 'login') {
      next()
    } else {
      next({name: 'login'})
    }
  }
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
